import AutoAwesome from "@mui/icons-material/AutoAwesome";
import { Fab, keyframes, Tooltip, Zoom } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(25, 118, 210, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(25, 118, 210, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(25, 118, 210, 0);
  }
`;

const StyledFab = styled(Fab)(({ theme }) => ({
  position: "fixed",
  bottom: theme.spacing(3),
  right: theme.spacing(3),
  zIndex: 1000,
  transition: "all 0.3s ease-in-out",
  "&:hover": {
    transform: "scale(1.1)",
  },
  animation: `${pulse} 2s infinite`,
}));

interface FloatingAssistantBubbleProps {
  onClick: () => void;
  isOpen: boolean;
}

const FloatingAssistantBubble: React.FC<FloatingAssistantBubbleProps> = ({
  onClick,
  isOpen,
}) => {
  return (
    <Zoom in={!isOpen}>
      <Tooltip title="Chat with Assistant" placement="left">
        <StyledFab
          color="primary"
          aria-label="chat"
          onClick={onClick}
          size="large"
        >
          <AutoAwesome />
        </StyledFab>
      </Tooltip>
    </Zoom>
  );
};

export default FloatingAssistantBubble;
